<template>
    <div>
        <!-- Search Section -->
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
                <!-- Updated flex container with justify-content: space-between -->
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 1rem; margin-top: 1rem; justify-content: space-between">
                    <div style="flex: 1; min-width: 300px" class="p-formgrid p-grid p-col">
                        <div class="p-field p-col-12 p-lg-2">
                            <label>{{ $t('starttime') }}</label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="endtime"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :showTime="true"
                                :showSeconds="true"
                                yearRange="2000:2050"
                                :locale="th"
                                v-model="starttime"
                                :class="errorStartTime ? 'p-invalid' : null"
                            ></Calendar>
                            <small v-if="errorStartTime" class="p-error">{{ $t('invalid_starttime') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label>{{ $t('endtime') }}</label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :showTime="true"
                                :showSeconds="true"
                                yearRange="2000:2050"
                                :locale="th"
                                v-model="endtime"
                                :class="errorEndTime ? 'p-invalid' : null"
                            ></Calendar>
                            <small v-if="errorEndTime" class="p-error">{{ $t('invalid_endtime') }}</small>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid p-jc-end p-mt-4">
                                <div class="p-field p-col-12 p-mt-2">
                                    <Button @click="clearSearchField()" :label="$t('clearBtn')" class="p-button-clear p-mr-3" />
                                    <Button @click="initialData()" :label="$t('searchBtn')" class="p-button-info p-mr-2" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-container" style="flex: 1; min-width: 300px">
                        <div class="stat-item">
                            <span class="stat-label">วันที่ค้นหาข้อมูล</span>
                            <strong class="stat-value">{{ getCurrentThaiDate() }}</strong>
                        </div>
                        <div class="stat-item">
                            <span class="stat-label">หน่วยงานที่เข้าปรับปรุงข้อมูล</span>
                            <strong class="stat-value">{{ Number(this.totalOrganize.length).toLocaleString('en-US') }}</strong>
                            <span class="stat-note">หน่วยงาน</span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-label">จำนวนการจัดการข้อมูล</span>
                            <strong class="stat-value">{{ Number(totalRecords).toLocaleString('en-US') }}</strong>
                            <span class="stat-note">รายการ</span>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="actionLogs_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 1rem; margin-top: 1rem">
            <!-- Summary Table -->
            <div style="flex: 1; min-width: 300px">
                <div class="card p-fluid p-mt-2">
                    <DataTable
                        :value="summaryTable"
                        class="styled-table"
                        :scrollable="true"
                        scrollHeight="500px"
                        ref="dt1"
                        :lazy="true"
                        :exportFilename="`รายงานสรุปหน่วยงานที่มีการตรวจสอบสภาพยานพาหนะ และรายงานสถานะ-${date}`"
                        sortField="index_1"
                        :sortOrder="1"
                        dataKey="id"
                        :paginator="false"
                        :selection.sync="selectedSummaryLogs"
                        :filters="filters_1"
                        :rows="100"
                        :rowHover="true"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rowsPerPageOptions="[10, 20, 50, 100]"
                        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                        :loading="loading"
                    >
                        <template #header>
                            <div class="p-grid p-col">
                                <div class="table-header" style="padding: 7px">
                                    <Button @click="exportCSV1()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                                </div>
                                <div class="table-header" style="padding: 7px">
                                    <SplitButton
                                        label="ส่งออก PDF"
                                        :model="items_1"
                                        class="p-button-raised p-button-danger"
                                        style="background-color: #f33737"
                                    ></SplitButton>
                                </div>
                                <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                                    <Button
                                        @click="EditPDF_1()"
                                        icon="pi pi-cog"
                                        :label="'ตั้งค่า'"
                                        style="background-color: #0288d1; border: 1px solid #0288d1"
                                    />
                                </div>
                                <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                                    <span class="p-input-icon-left" v-if="columns_disabled">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filter_1" @input="searchTable_1()" :placeholder="$t('searchHeader')" />
                                    </span>
                                    <span class="p-input-icon-left" v-else>
                                        <i class="pi pi-search" />
                                        <InputText disabled v-model="filter_1" @input="searchTable_1()" :placeholder="$t('searchHeader')" />
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #empty>{{ $t('TableEmpty') }}</template>
                        <Column field="index_1" header="ลำดับ" headerStyle="width: 4rem">
                            <template #body="slotProps">
                                {{ slotProps.data.index_1 }}
                            </template>
                        </Column>

                        <Column field="organize_name" :header="$t('หน่วยงาน')" headerStyle="width: 20rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.organize_name">-</div>
                                {{ slotProps.data.organize_name }}
                            </template>
                        </Column>

                        <Column field="status1" :header="$t('พร้อมใช้')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.status1">-</div>
                                {{ Number(slotProps.data.status1).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="status2" :header="$t('ซ่อม')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.status2">-</div>
                                {{ Number(slotProps.data.status2).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="status3" :header="$t('ชำรุด')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.status3">-</div>
                                {{ Number(slotProps.data.status3).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="status4" :header="$t('รอจำหน่าย')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.status4">-</div>
                                {{ Number(slotProps.data.status4).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="status5" :header="$t('จำหน่าย')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.status5">-</div>
                                {{ Number(slotProps.data.status5).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <Column field="status6" :header="$t('อุปกรณ์ชำรุด')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.status6">-</div>
                                {{ Number(slotProps.data.status6).toLocaleString('en-US') }}
                            </template>
                        </Column>

                        <!-- For example, use total to show the vehicle status -->
                        <Column field="total" :header="$t('รวม')" headerStyle="width: 7rem">
                            <template #body="slotProps">
                                <div v-if="!slotProps.data.total">-</div>
                                {{ Number(slotProps.data.total).toLocaleString('en-US') }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>

            <!-- Action Logs Table -->
            <div style="flex: 1; min-width: 300px">
                <div class="card p-fluid p-mt-2">
                    <DataTable
                        :value="actionLogs_table"
                        :scrollable="true"
                        scrollHeight="500px"
                        :lazy="true"
                        :paginator="true"
                        :rows="lazyParams.rows"
                        :totalRecords="totalRecords"
                        @page="onPage($event)"
                        @sort="onSort($event)"
                        :sortField="lazyParams.sortField"
                        :sortOrder="lazyParams.sortOrder"
                        dataKey="id"
                        ref="dt"
                        :exportFilename="`รายงานหน่วยงานที่มีการตรวจสอบสภาพยานพาหนะ และรายงานสถานะ-${date}`"
                        :rowHover="true"
                        :selection.sync="selectedActionLogs"
                        :filters="filters"
                        :rowsPerPageOptions="[10, 20, 50]"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords} รายการ"
                        :loading="loading"
                    >
                        <template #header>
                            <div class="p-grid p-col">
                                <div class="table-header" style="padding: 7px">
                                    <Button @click="exportCSV()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                                </div>
                                <div class="table-header" style="padding: 7px">
                                    <SplitButton
                                        label="ส่งออก PDF"
                                        :model="items"
                                        class="p-button-raised p-button-danger"
                                        style="background-color: #f33737"
                                    ></SplitButton>
                                </div>
                                <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                                    <Button
                                        @click="EditPDF()"
                                        icon="pi pi-cog"
                                        :label="'ตั้งค่า'"
                                        style="background-color: #0288d1; border: 1px solid #0288d1"
                                    />
                                </div>
                                <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                                    <span class="p-input-icon-left" v-if="columns_disabled">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                                    </span>
                                    <span class="p-input-icon-left" v-else>
                                        <i class="pi pi-search" />
                                        <InputText disabled v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #empty>{{ $t('TableEmpty') }}</template>

                        <Column header="ลำดับ" headerStyle="width: 4rem">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.index == null">-</div>
                                {{ slotProps.data.index }}
                            </template>
                        </Column>

                        <div v-if="columns_user_fullname == true">
                            <Column field="user_fullname" :header="$t('imp_organize')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    <div v-if="dataTable.data.user_fullname == null">-</div>
                                    {{ dataTable.data.user_fullname }}
                                </template>
                            </Column>
                        </div>
                        <div v-else>
                            <Column headerStyle="width: 0"></Column>
                        </div>

                        <div v-if="columns_action_time == true">
                            <Column field="action_time" :header="$t('action_time')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    {{ dataTable.data.action_time }}
                                </template>
                            </Column>
                        </div>
                        <div v-else>
                            <Column headerStyle="width: 0"></Column>
                        </div>

                        <div v-if="columns_topic == true">
                            <Column field="topic" :header="$t('action_topic')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    {{ dataTable.data.topic }}
                                </template>
                            </Column>
                        </div>
                        <div v-else>
                            <Column headerStyle="width: 0"></Column>
                        </div>

                        <!-- รอคอนเฟิร์ม-->
                        <div v-if="columns_detail == true">
                            <Column field="detail" :header="$t('action_logs_details')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    <div
                                        @click="showDetailDialog(dataTable.data)"
                                        style="cursor: pointer; color: #2196f3; text-decoration: underline"
                                    >
                                        รายละเอียด
                                    </div>
                                </template>
                            </Column>
                        </div>
                    </DataTable>
                </div>
            </div>
        </div>

        <!-- Other Dialogs -->
        <Dialog
            :modal="true"
            :header="$t('OrganizeModalHeader')"
            :visible.sync="showOrganize"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
        >
            <organize-table @selectOrganization="selectedOrganize_passValue"></organize-table>
        </Dialog>

        <Dialog
            :modal="true"
            :header="$t('action_logs_deep_details')"
            :visible.sync="showLogsDetail"
            :style="{ width: '90%', maxWidth: '1200px' }"
            :contentStyle="{ 'overflow-y': 'auto', 'max-height': '80vh' }"
        >
            <div class="detail-content p-mt-5 p-mb-5">
                <!-- Replace the empty div with v-html binding -->
                <div v-html="formattedContent"></div>
            </div>
            <template #footer>
                <Button @click="showLogsDetail = false" :label="$t('ปิด')" icon="pi pi-times" class="p-button-text" />
            </template>
        </Dialog>

        <Dialog :header="$t('json')" :visible.sync="displayInfo" :style="{ width: 'max-content' }">
            <div class="p-mt-5 p-mb-5">
                <pre id="json"></pre>
            </div>
        </Dialog>

        <!-- Edit PDF Dialog -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>

        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF_1" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog_1"
                            :options="columns_1"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue_1"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF_1();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF_1()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF_1()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF_1()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import organizeTable from '../../Information/OrganizeTable.vue';
import moment from 'moment';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'report-logs',
    components: {
        organizeTable,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchDelay: 500,
            lazyParams: {
                page: 1,
                rows: 10,
                sortField: 'date',
                sortOrder: 1
            },
            summaryLazyParams: {
                page: 1,
                rows: 10,
                sortField: 'index_1',
                sortOrder: 1
            },
            summaryTotalRecords: 0,
            totalRecords: 0,

            columns_detail: true,
            formattedContent: '',
            dialogHeader: 'รายละเอียด',
            currentDetail: null,
            showLogsDetail: false,
            summaryTable: [],
            filters_1: {},
            selectedSummaryLogs: [],
            loading: false,
            date: moment().locale('th').add(543, 'year').format('l'),

            multiSelectClearFilerValue_1: 0,
            index: 1,
            multiSelectClearFilerValue: 0,
            // date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            filter_1: '',
            count: false,
            cloneTable: [],
            cloneTable_1: [],
            // Doe ค้นหา  2/5 จบ

            selectedActionLogs: null,

            actionLogs_table: [],
            totalOrganize: [],
            filters: {},

            showOrganize: false,
            selectedOrganize: {
                id: null,
                name: ''
            },
            dateYear: '',
            starttime: null,
            endtime: null,
            displayInfo: false,
            infoText: null,

            errorStartTime: false,
            errorEndTime: false,

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'รายงานหน่วยงานที่มีการตรวจสอบสภาพยานพาหนะ และรายงานสถานะ',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 15,
            PDF_FontBodyVer: 12,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 35 },
                user_fullname: { cellWidth: 80 }
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'หน่วยงาน', dataKey: 'user_fullname' },
                { title: 'วันเวลาที่จัดการข้อมูล', dataKey: 'action_time' },
                { title: 'การจัดการ', dataKey: 'topic' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_user_fullname: true,

            columns_action_type: true,
            columns_action_time: true,
            columns_topic: true,

            columns_disabled: true,
            GetData_ColumnsSearch: [],
            // Doe PDF เลือกได้  2/5  จบ

            // Doe PDF เลือกได้  2/5
            setPDF_Hor_1: 'l',
            setPosition_Hor_1: [802, 34, 802, 570],
            setPDF_Ver_1: 'p',
            setPosition_Ver_1: [570, 34, 575, 815],
            setPDF_Styles_1: 'grid',
            setnamePDF_1: 'รายงานสรุปหน่วยงานที่มีการตรวจสอบสภาพยานพาหนะ และรายงานสถานะ',
            setPDF_fillColor_1: [95, 154, 250],
            setPDF_Margin_1: { left: 15, right: 15 },

            PDF_minCellWidthVer_1: 70,
            PDF_FontHeaderVer_1: 15,
            PDF_FontBodyVer_1: 12,

            PDF_BodySizeSelect_1: {},
            PDF_BodySize_1: {
                index: { cellWidth: 35 },
                user_fullname: { cellWidth: 80 }
            },

            PDF_minCellWidthHor_1: 70,
            PDF_FontHeaderHor_1: 15,
            PDF_FontBodyHor_1: 12,

            PDF_BodySizeHorSelect_1: {},
            PDF_BodySizeHor_1: {
                index: { cellWidth: 35 }
            },
            columns_1: [
                { title: 'ลำดับ', dataKey: 'index_1' },
                { title: 'หน่วยงาน', dataKey: 'organize_name' },
                { title: 'พร้อมใช้', dataKey: 'status1' },
                { title: 'ซ่อม', dataKey: 'status2' },
                { title: 'ชำรุด', dataKey: 'status3' },
                { title: 'รอจำหน่าย', dataKey: 'status4' },
                { title: 'จำหน่าย', dataKey: 'status5' },
                { title: 'อุปกรณ์ชำรุด', dataKey: 'status6' },
                { title: 'รวม', dataKey: 'total' }
            ],

            columnsSelector_1: null,
            columnsSelectorDialog_1: null,

            displayEditPDF_1: false,

            index_1: 1,
            columns_index_1: true,
            columns_user_fullname_1: true,

            columns_action_type_1: true,
            columns_action_time_1: true,
            columns_topic_1: true,

            columns_disabled_1: true,
            GetData_ColumnsSearch_1: [],
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'สังกัด',
                    textShow: ''
                },
                {
                    DataName: 'เวลาเริ่มต้น',
                    textShow: ''
                },
                {
                    DataName: 'เวลาสิ้นสุด',
                    textShow: ''
                }
            ],
            items: [
                {
                    label: ' แนวตั้ง',
                    command: async () => {
                        try {
                            await this.initialAllData(); // Search all data before export
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns = this.columnsSelector;
                            const Body_setCenter = ['index'];

                            const PintPDF = {
                                streak: this.setPDF_Ver,
                                setPosition: this.setPosition_Ver,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer,
                                Body_FontSize: this.PDF_FontBodyVer,
                                minCell: this.PDF_minCellWidthVer,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to generate PDF',
                                life: 3000
                            });
                            // console.error('Error generating PDF:', error);
                        }
                    }
                },
                {
                    label: 'แนวนอน',
                    command: async () => {
                        try {
                            await this.initialAllData(); // Search all data before export
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                            let columns = this.columnsSelector;
                            const Body_setCenter = ['index'];

                            const PintPDF = {
                                streak: this.setPDF_Hor,
                                setPosition: this.setPosition_Hor,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeHorSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor,
                                Body_FontSize: this.PDF_FontBodyHor,
                                minCell: this.PDF_minCellWidthHor,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to generate PDF',
                                life: 3000
                            });
                            console.error('Error generating PDF:', error);
                        }
                    }
                }
            ],

            items_1: [
                {
                    label: ' แนวตั้ง',
                    command: async () => {
                        try {
                            await this.initialAllData(); // Search all data before export
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns_1 = this.columnsSelector_1;
                            const Body_setCenter = ['index'];

                            const PintPDF = {
                                streak: this.setPDF_Ver_1,
                                setPosition: this.setPosition_Ver_1,
                                PDF_Styles: this.setPDF_Styles_1,
                                data: this.$refs.dt1.processedData,
                                columns: columns_1,
                                columnsStyles: this.PDF_BodySizeSelect_1,
                                FileName: this.setnamePDF_1,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer_1,
                                Body_FontSize: this.PDF_FontBodyVer_1,
                                minCell: this.PDF_minCellWidthVer_1,
                                marginPDF: this.setPDF_Margin_1,
                                fillColorPDF: this.setPDF_fillColor_1
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to generate PDF',
                                life: 3000
                            });
                            console.error('Error generating PDF:', error);
                        }
                    }
                },
                {
                    label: 'แนวนอน',
                    command: async () => {
                        try {
                            await this.initialAllData(); // Search all data before export
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                            let columns_1 = this.columnsSelector_1;
                            const Body_setCenter = ['index'];

                            const PintPDF = {
                                streak: this.setPDF_Hor_1,
                                setPosition: this.setPosition_Hor_1,
                                PDF_Styles: this.setPDF_Styles_1,
                                data: this.$refs.dt1.processedData,
                                columns: columns_1,
                                columnsStyles: this.PDF_BodySizeHorSelect_1,
                                FileName: this.setnamePDF_1,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor_1,
                                Body_FontSize: this.PDF_FontBodyHor_1,
                                minCell: this.PDF_minCellWidthHor_1,
                                marginPDF: this.setPDF_Margin_1,
                                fillColorPDF: this.setPDF_fillColor_1
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to generate PDF',
                                life: 3000
                            });
                            console.error('Error generating PDF:', error);
                        }
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        selectedOrganize(val) {
            if (val != '') {
                this.showOrganize = false;
            }
        },

        displayInfo(val) {
            if (val) {
                setTimeout(() => {
                    document.getElementById('json').textContent = JSON.stringify(JSON.parse(this.infoText), undefined, 2);
                }, 500);
            }
        },

        starttime(val) {
            if (val) {
                this.errorStartTime = false;
            }
        },
        endtime(val) {
            if (val) {
                this.errorEndTime = false;
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.actionLogs_table = [];
            } else {
                this.actionLogs_table = this.cloneTable;
            }
        },
        columnsSelector_1(val) {
            if (val.length == 0) {
                this.summaryTable.summaryPercentage = [];
            } else {
                this.summaryTable.summaryPercentage = this.cloneTable_1;
            }
        }
    },
    created() {
        const yy = new Date();
        const yyyy = parseInt(yy.getFullYear()) + 543;
        this.dateYear = yyyy;
        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // Doe PDF เลือกได้  4/5  จบ

        // this.initialData();

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },
    mounted() {
        this.SelectAllEditPDF_1();
        this.SaveEditPDF_1();
    },
    methods: {
        // Method to show detail dialog and format data
        showDetailDialog(rowData) {
            try {
                // Set dialog header based on topic
                if (rowData.topic.includes('เพิ่มข้อมูล')) {
                    this.dialogHeader = 'รายละเอียดการเพิ่มข้อมูล';
                } else if (rowData.topic.includes('แก้ไขข้อมูล')) {
                    this.dialogHeader = 'รายละเอียดการแก้ไขข้อมูล';
                } else if (rowData.topic.includes('ลบข้อมูล')) {
                    this.dialogHeader = 'รายละเอียดการลบข้อมูล';
                } else {
                    this.dialogHeader = 'รายละเอียด';
                }

                // Store current detail for processing
                this.currentDetail = rowData.detail;

                // Format the content before showing the dialog
                this.formatDetailContent(rowData.detail, rowData.topic);

                // Now show the dialog after content is formatted
                this.showLogsDetail = true;
            } catch (e) {
                console.error('Error preparing dialog:', e);
            }
        },

        // Function to format the detail content
        formatDetailContent(detailData, topic) {
            try {
                // Parse the JSON string to an object
                const parsedData = typeof detailData === 'string' ? JSON.parse(detailData) : detailData;

                let formattedHTML = '';

                // Create header with styling
                formattedHTML += '<div style="font-family: Arial, sans-serif; padding: 15px;">';

                // Generate content based on topic type
                if (topic.includes('เพิ่มข้อมูล')) {
                    // For "Add" action - show all data
                    formattedHTML += `<div style="background-color: #555; color: white; padding: 10px; border-radius: 5px; font-weight: bold; display: inline-block; margin-bottom: 10px;">เพิ่มข้อมูล ยานพาหนะ</div>`;
                    formattedHTML += this.formatDataSection(parsedData.updated_data || parsedData, 'ข้อมูลที่เพิ่ม');
                } else if (topic.includes('ลบข้อมูล')) {
                    // For "Delete" action - show all data
                    formattedHTML += `<div style="background-color: #555; color: white; padding: 10px; border-radius: 5px; font-weight: bold; display: inline-block; margin-bottom: 10px;">ลบข้อมูล ยานพาหนะ</div>`;
                    formattedHTML += this.formatDataSection(parsedData.previous_data || parsedData, 'ข้อมูลที่ถูกลบ');
                } else if (topic.includes('แก้ไขข้อมูล')) {
                    // For "Edit" action - show comparison between previous and updated data
                    formattedHTML += `<div style="background-color: #555; color: white; padding: 10px; border-radius: 5px; font-weight: bold; display: inline-block; margin-bottom: 10px;">แก้ไขข้อมูล ยานพาหนะ</div>`;
                    formattedHTML += this.compareData(parsedData.previous_data, parsedData.updated_data);
                } else {
                    // Default case
                    formattedHTML += this.formatDataSection(parsedData, 'ข้อมูลรายละเอียด');
                }

                formattedHTML += '</div>';

                // Set the formatted HTML content to the reactive property
                this.formattedContent = formattedHTML;
            } catch (e) {
                console.error('Error parsing JSON:', e);
                this.formattedContent = `<div style="color: red; padding: 15px;">Error parsing detail data: ${e.message}</div>`;
            }
        },

        // Helper function to format a data section
        formatDataSection(data, title) {
            if (!data) return '';

            let html = `<div style="margin-top: 15px;">
                         <div style="background-color: #555; color: white; text-align: center; padding: 10px; font-weight: bold; margin-bottom: 1px;">${title}</div>
                       <div style="background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 0px; padding: 0px;">
                           <table style="width: 100%; border-collapse: collapse;">`;

            // Process each property in the data
            Object.entries(data).forEach(([key, value]) => {
                // Format the key for display
                const displayKey = this.formatKeyName(key);

                // Format the value based on its type
                let displayValue = this.formatValue(value);

                html += `<tr>
                        <td style="padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold; width: 30%;">${displayKey}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #ddd;">${displayValue}</td>
                    </tr>`;
            });

            html += `</></div></div>`;
            return html;
        },

        // Helper function to compare previous and updated data
        compareData(previous, updated) {
            if (!previous || !updated) return '';

            const excludedKeys = ['user_id', 'ev_amount'];

            // Create the container with two columns
            let html = `<div style="display: flex; flex-direction: row; margin-top: 15px; gap: 20px;">
                <div style="flex: 1;">
                    <div style="background-color: #555; color: white; text-align: center; padding: 10px; font-weight: bold; margin-bottom: 1px;">ข้อมูลก่อนปรับแก้</div>
                    <div style="background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 0px; padding: 0px;">
                        <table style="width: 100%; border-collapse: collapse;">`;

            // Create a set of all keys from both objects
            const allKeys = new Set([
                ...Object.keys(previous).filter((key) => !excludedKeys.includes(key)),
                ...Object.keys(updated).filter((key) => !excludedKeys.includes(key))
            ]);

            // Process each key in previous data
            allKeys.forEach((key) => {
                const prevValue = previous[key];
                const newValue = updated[key];
                const hasChanged = JSON.stringify(prevValue) !== JSON.stringify(newValue);

                const displayKey = this.formatKeyName(key);
                const displayValue = this.formatValue(prevValue);

                const rowStyle = hasChanged ? 'background-color: #FFCDD2;' : '';
                const tdStyle = 'padding: 8px; border-bottom: 1px solid #ddd;';

                html += `<tr style="${rowStyle}">
                <td style="${tdStyle} font-weight: bold; width: 30%; border-right: 1px dotted #ccc;">${displayKey}</td>
                <td style="${tdStyle}">${displayValue}</td>
            </tr>`;
            });

            html += `</table></div></div>
             <div style="flex: 1;">
                <div style="background-color: #555; color: white; text-align: center; padding: 10px; font-weight: bold; margin-bottom: 1px;">ข้อมูลหลังปรับแก้</div>
                <div style="background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 0px; padding: 0px;">
                    <table style="width: 100%; border-collapse: collapse;">`;

            // Process each key in updated data
            allKeys.forEach((key) => {
                const prevValue = previous[key];
                const newValue = updated[key];
                const hasChanged = JSON.stringify(prevValue) !== JSON.stringify(newValue);

                const displayKey = this.formatKeyName(key);
                const displayValue = this.formatValue(newValue);

                // Use a subtle green background for changed fields
                const rowStyle = hasChanged ? 'background-color: #e8f5e9;' : '';
                const tdStyle = 'padding: 8px; border-bottom: 1px solid #ddd;';

                // If there's a green field in the screenshot, add a green border
                const valueCellStyle = hasChanged ? `${tdStyle} border: 1px solid #4CAF50;` : tdStyle;

                html += `<tr style="${rowStyle}">
                <td style="${tdStyle} font-weight: bold; width: 30%; border-right: 1px dotted #ccc;">${displayKey}</td>
                <td style="${valueCellStyle}">${displayValue}</td>
            </tr>`;
            });

            html += `</table></div></div></div>`;
            return html;
        },

        // Helper function to format key names for better display
        formatKeyName(key) {
            // Map of field names to Thai translations
            const keyTranslations = {
                ev_id: 'รหัสอุปกรณ์',
                ev_code: 'หมายเลขอุปกรณ์',
                ev_community: 'ชุมชน',
                ev_name: 'ชื่ออุปกรณ์',
                ev_lat: 'ละติจูด',
                ev_lon: 'ลองจิจูด',
                ev_standard_name: 'ชื่อมาตรฐาน',
                ev_organize: 'หน่วยงาน',
                ev_group: 'กลุ่มเครื่องมือ',
                ev_type: 'ประเภทเครื่องมือ',
                ev_number: 'หมายเลขครุภัณฑ์',
                ev_amount: 'จำนวน',
                ev_status: 'สถานะ',
                ev_license_plate: 'เลขทะเบียน',
                ev_sidecar_number: 'หมายเลขข้างรถ',
                ev_car_brand: 'ยี่ห้อรถ',
                ev_received_date: 'วันที่ได้รับ',
                ev_date: 'วันที่',
                ev_response_name: 'ชื่อผู้รับผิดชอบ',
                ev_response_position: 'ตำแหน่งผู้รับผิดชอบ',
                ev_response_phone: 'เบอร์โทรผู้รับผิดชอบ',
                ev_detail: 'รายละเอียด',
                ev_maintenance_table: 'ตารางการซ่อมบำรุง',
                ev_maintenance_table2: 'ตารางการซ่อมบำรุง 2',
                ev_borrowing_history: 'ประวัติการยืม',
                ev_vehicledevice_table: 'ตารางอุปกรณ์ประจำรถ',
                tel_detail: 'รายละเอียดเบอร์โทร',
                remind_check: 'แจ้งเตือนการตรวจสอบ',
                editor: 'ผู้แก้ไข',
                date_update: 'วันที่ปรับปรุงข้อมูล',
                user_organize: 'หน่วยงาานที่รับผิดชอบ',
                equipment_community: 'ชุมชน'
            };

            return keyTranslations[key] || key;
        },

        // Helper function to format values for display
        formatValue(value) {
            if (value === null || value === undefined) {
                return '<span style="color: #999;">- ไม่มีข้อมูล -</span>';
            }

            if (typeof value === 'object') {
                // For objects, display formatted JSON
                return `<pre style="margin: 0; white-space: pre-wrap;">${JSON.stringify(value, null, 2)}</pre>`;
            }

            // Status codes translation
            if (typeof value === 'string' && value.length === 1 && /^[1-5]$/.test(value)) {
                const statusMap = {
                    1: 'พร้อมใช้',
                    2: 'ซ่อม',
                    3: 'ชำรุด',
                    4: 'รอจำหน่าย',
                    5: 'จำหน่าย'
                };

                if (statusMap[value]) {
                    return ` ${statusMap[value]}`;
                }
            }

            if (typeof value === 'string' && ['device', 'vehicle'].includes(value)) {
                const evGroupMap = {
                    device: 'เครื่องมืออุปกรณ์',
                    vehicle: 'ยานพาหนะ'
                };

                if (evGroupMap[value]) {
                    return evGroupMap[value];
                }
            }

            // Try to parse potential JSON strings
            if (typeof value === 'string' && (value.startsWith('[') || value.startsWith('{'))) {
                try {
                    const parsedJson = JSON.parse(value);

                    // If it's a maintenance table, format it specially
                    if (Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson[0].detail_text) {
                        let maintenanceHtml = '<div style="max-height: 300px; overflow-y: auto;">';
                        parsedJson.forEach((item) => {
                            maintenanceHtml += `<div style="margin-bottom: 10px; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
                                                <strong>ผู้รายงาน:</strong> ${item.name} (${item.tel})<br>
                                                ${item.detail_text}
                                                </div>`;
                        });
                        maintenanceHtml += '</div>';
                        return maintenanceHtml;
                    }

                    // If it's device table, format it specially
                    if (Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson[0].device_name) {
                        let deviceHtml = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                        deviceHtml += `<tr style="background-color: #f2f2f2;">
                                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">อุปกรณ์</th>
                                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ขนาด</th>
                                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">จำนวน</th>
                                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">หน่วย</th>
                                     </tr>`;

                        parsedJson.forEach((device) => {
                            deviceHtml += `<tr>
                                        <td style="padding: 8px; border: 1px solid #ddd;">${device.device_name}</td>
                                        <td style="padding: 8px; border: 1px solid #ddd;">${device.size || '-'}</td>
                                        <td style="padding: 8px; border: 1px solid #ddd;">${device.amount}</td>
                                        <td style="padding: 8px; border: 1px solid #ddd;">${device.unit}</td>
                                        </tr>`;
                        });

                        deviceHtml += '</table>';
                        return deviceHtml;
                    }

                    // Format tel_detail specially
                    if (Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson[0].tel !== undefined) {
                        let telHtml = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                        telHtml += `<tr style="background-color: #f2f2f2;">
                                 <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">เบอร์มือถือ</th>
                                 <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">เบอร์โทรศัพท์</th>
                                 <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ต่อ</th>
                                 </tr>`;

                        parsedJson.forEach((tel) => {
                            telHtml += `<tr>
                                    <td style="padding: 8px; border: 1px solid #ddd;">${tel.phone || '-'}</td>
                                    <td style="padding: 8px; border: 1px solid #ddd;">${tel.tel || '-'}</td>
                                    <td style="padding: 8px; border: 1px solid #ddd;">${tel.tel_ext || '-'}</td>
                                    </tr>`;
                        });

                        telHtml += '</table>';
                        return telHtml;
                    }

                    // For other JSON structures, display as formatted JSON
                    return `<pre style="margin: 0; max-height: 200px; overflow-y: auto; white-space: pre-wrap;">${JSON.stringify(
                        parsedJson,
                        null,
                        2
                    )}</pre>`;
                } catch (e) {
                    // If parsing fails, return as-is
                    console.warn('JSON parsing failed for:', value);
                }
            }

            // Format dates if applicable
            if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}(T|\s)/)) {
                try {
                    // Use moment for Thai calendar (Buddhist Era - add 543 years)
                    return moment(value).locale('th').add(543, 'year').format('LL');
                } catch (e) {
                    // If date parsing fails, return as-is
                }
            }

            return value;
        },

        getCurrentThaiDate() {
            return moment().locale('th').add(543, 'year').format('D MMMM YYYY');
        },

        async runSequentially() {
            this.SelectAllEditPDF_1();
            this.SaveEditPDF_1();
            await this.initialData();
        },
        async exportCSV() {
            await this.initialAllData();
            this.$refs.dt.exportCSV();
        },

        async exportCSV1() {
            await this.initialAllData();
            this.$refs.dt1.exportCSV();
        },

        async searchTable() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            this.searchTimeout = setTimeout(async () => {
                try {
                    this.loading = true;

                    // Reset to first page when searching
                    this.lazyParams = {
                        ...this.lazyParams,
                        page: 1
                    };

                    const response = await this.axios.post(`${this.$url_service}/bangkokOrg/weekly/equipment/report/pagination/search`, {
                        starttime: this.starttime ? moment(this.starttime).format('YYYY-MM-DD HH:mm:ss') : null,
                        endtime: this.endtime ? moment(this.endtime).format('YYYY-MM-DD HH:mm:ss') : null,
                        pagination: {
                            page: this.lazyParams.page,
                            limit: this.lazyParams.rows
                        },
                        sort: {
                            field: this.lazyParams.sortField,
                            order: this.lazyParams.sortOrder
                        },
                        search: {
                            filter: this.filter ? this.filter.toLowerCase().trim() : '',
                            column: 'user_fullname'
                        }
                    });

                    if (response.data && response.data.code === 'success') {
                        // Update main data table
                        this.actionLogs_table = response.data.data.map((item, index) => ({
                            ...item,
                            index: (this.lazyParams.page - 1) * this.lazyParams.rows + index + 1,
                            action_time: moment(item.date).locale('th').add(543, 'year').format('LLL'),
                            topic: this.formatTopic(item.topic),
                            user_fullname: item.user_fullname || '-',
                            organize_name: item.organize_name || '-'
                        }));

                        // Update metadata
                        this.totalRecords = response.data.metadata.total;
                        this.totalOrganize = response.data.metadata.summaryPercentage || [];

                        // Update clone tables
                        this.cloneTable = [...this.actionLogs_table];
                    }
                } catch (error) {
                    console.error('Error searching data:', error?.response?.data?.details || error.message);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to search data: ' + (error?.response?.data?.message || 'Unknown error'),
                        life: 3000
                    });
                } finally {
                    this.loading = false;
                }
            }, this.searchDelay);
        },

        async searchTable_1() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            this.searchTimeout = setTimeout(async () => {
                try {
                    this.loading = true;
                    const searchTerm = this.filter_1 ? this.filter_1.toLowerCase().trim() : '';

                    // If no search term, restore from clone
                    if (!searchTerm) {
                        this.summaryTable = [...this.cloneTable_1];
                        this.loading = false;
                        return;
                    }

                    // Filter summaryTable based on organize_name
                    this.summaryTable = this.cloneTable_1.filter((item) => {
                        const organize_name = item.organize_name ? String(item.organize_name).toLowerCase() : '-';
                        return organize_name.includes(searchTerm);
                    });

                    // Update indexes after filtering
                    this.summaryTable = this.summaryTable.map((item, index) => ({
                        ...item,
                        index_1: index + 1
                    }));
                } catch (error) {
                    console.error('Error searching summary data:', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to search summary data',
                        life: 3000
                    });
                } finally {
                    this.loading = false;
                }
            }, this.searchDelay);
        },

        formatTopic(topic) {
            if (!topic) return '-';

            const parts = topic.split(' ');
            const action = parts[0];
            const rest = parts.slice(1).join(' ');
            const vehicleText = 'ยานพาหนะ';

            // Handle equipment case
            if (rest.toLowerCase().includes('equipment')) {
                switch (action.toLowerCase()) {
                    case 'add':
                        return `เพิ่มข้อมูล${vehicleText}`;
                    case 'edit':
                        return `แก้ไขข้อมูล${vehicleText}`;
                    case 'delete':
                        return `ลบข้อมูล${vehicleText}`;
                    default:
                        return topic;
                }
            }

            // Handle direct vehicle case (ยานพาหนะ)
            if (rest.includes('ยานพาหนะ')) {
                switch (action.toLowerCase()) {
                    case 'add':
                        return `เพิ่มข้อมูล ${rest}`;
                    case 'edit':
                        return `แก้ไขข้อมูล ${rest}`;
                    case 'delete':
                        return `ลบข้อมูล ${rest}`;
                    default:
                        return topic;
                }
            }

            // Handle other cases
            switch (action.toLowerCase()) {
                case 'add':
                    return `เพิ่มข้อมูล ${rest}`;
                case 'edit':
                    return `แก้ไขข้อมูล ${rest}`;
                case 'delete':
                    return `ลบข้อมูล ${rest}`;
                default:
                    return topic;
            }
        },

        async initialAllData() {
            try {
                this.filter = '';
                this.filter_1 = '';
                this.cloneTable = [];
                this.summaryTable = [];

                // Validation for starttime and endtime inputs
                if (this.starttime && !this.endtime) {
                    this.errorEndTime = true;
                    return;
                } else if (!this.starttime && this.endtime) {
                    this.errorStartTime = true;
                    return;
                }

                this.loading = true;

                // Format the starttime and endtime using moment.js
                const formattedStartTime = this.starttime ? moment(this.starttime).format('YYYY-MM-DD HH:mm:ss') : null;
                const formattedEndTime = this.endtime ? moment(this.endtime).format('YYYY-MM-DD HH:mm:ss') : null;

                // Use the original endpoint for all data
                const response = await this.axios.post(`${this.$url_service}/bangkokOrg/weekly/equipment/report`, {
                    starttime: formattedStartTime,
                    endtime: formattedEndTime
                });

                if (response.data && response.data.code === 'success') {
                    // Process the response data
                    this.actionLogs_table = response.data.data.map((item, index) => ({
                        ...item,
                        index: index + 1,
                        action_time: moment(item.date).locale('th').add(543, 'year').format('LLL'),
                        topic: this.formatTopic(item.topic),
                        user_fullname: item.user_fullname || '-',
                        organize_name: item.organize_name || '-'
                    }));

                    // Update summary data
                    this.summaryTable = response.data.metadata.statusVehicleORganizeSummary.map((item, index) => ({
                        ...item,
                        index_1: index + 1,
                        organize_name: item.organize_name || '-'
                    }));

                    // Update metadata
                    this.totalRecords = response.data.metadata.total || response.data.data.length;
                    this.totalOrganize = response.data.metadata.summaryPercentage || [];

                    // Update clones for search functionality
                    this.cloneTable = [...this.actionLogs_table];
                    this.cloneTable_1 = [...this.summaryTable];

                    this.setSearchText_Footer();
                } else {
                    throw new Error('Invalid response format');
                }
            } catch (error) {
                // console.error('Error in initialAllData:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load all data',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        async initialData() {
            this.lazyParams = {
                page: 1,
                rows: 10,
                sortField: 'date',
                sortOrder: 1
            };
            await this.loadData();
        },

        // Add new loadData method for pagination
        async loadData() {
            try {
                this.loading = true;
                const response = await this.axios.post(`${this.$url_service}/bangkokOrg/weekly/equipment/report/pagination`, {
                    starttime: this.starttime ? moment(this.starttime).format('YYYY-MM-DD HH:mm:ss') : null,
                    endtime: this.endtime ? moment(this.endtime).format('YYYY-MM-DD HH:mm:ss') : null,
                    pagination: {
                        page: this.lazyParams.page,
                        limit: this.lazyParams.rows
                    },
                    sort: {
                        field: this.lazyParams.sortField,
                        order: this.lazyParams.sortOrder === 1 ? -1 : 1
                    }
                });

                if (response.data && response.data.code === 'success') {
                    // Update main data table
                    this.actionLogs_table = response.data.data.map((item, index) => ({
                        ...item,
                        index: (this.lazyParams.page - 1) * this.lazyParams.rows + index + 1,
                        action_time: moment(item.date).locale('th').add(543, 'year').format('LLL'),
                        topic: this.formatTopic(item.topic),
                        user_fullname: item.user_fullname || '-',
                        organize_name: item.organize_name || '-'
                    }));

                    // Update summary table
                    this.summaryTable = response.data.metadata.statusVehicleORganizeSummary.map((item, index) => ({
                        ...item,
                        index_1: index + 1,
                        organize_name: item.organize_name || '-'
                    }));

                    // Update metadata
                    this.totalRecords = response.data.metadata.total;
                    this.totalOrganize = response.data.metadata.summaryPercentage || [];

                    // Clone data for search functionality
                    this.cloneTable = [...this.actionLogs_table];
                    this.cloneTable_1 = [...this.summaryTable];
                } else {
                    throw new Error('Invalid response format');
                }
            } catch (error) {
                console.error('Error loading data:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load data',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        onPage(event) {
            this.lazyParams = {
                ...this.lazyParams,
                page: event.page + 1,
                rows: event.rows
            };

            // If there's a search term, reapply search with new page
            if (this.filter) {
                this.searchTable();
            } else {
                this.loadData();
            }
        },
        onRowsPerPageChange(event) {
            this.lazyParams = {
                ...this.lazyParams,
                page: 1,
                rows: event.rows
            };

            if (this.filter) {
                this.searchTable();
            } else {
                this.loadData();
            }
        },

        onSort(event) {
            this.lazyParams = {
                ...this.lazyParams,
                sortField: event.sortField,
                sortOrder: event.sortOrder
            };
            this.loadData();
        },

        setSearchText_Footer() {
            this.text_Footer = false;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.selectedOrganize.name !== '' || this.starttime !== null || this.endtime !== null) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'สังกัด' && this.selectedOrganize.name !== '') {
                        element.textShow = this.selectedOrganize.name;
                    }
                    if (element.DataName === 'เวลาเริ่มต้น' && this.starttime !== null) {
                        element.textShow = this.setDate(this.starttime);
                    }
                    if (element.DataName === 'เวลาสิ้นสุด' && this.endtime !== null) {
                        element.textShow = this.setDate(this.endtime);
                    }

                    this.text_Footer = true;
                }
            }
        },
        setDate(date) {
            if (typeof date === 'object') {
                const Thai_date = date.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });
                return Thai_date;
            } else {
                return date;
            }
        },
        selectedOrganize_passValue(variable) {
            this.selectedOrganize = {
                id: variable.organize_id,
                name: variable.organize_name
            };
        },

        clearSearchField() {
            this.selectedOrganize = { id: null, name: '' };
            this.starttime = null;
            this.endtime = null;
            this.initialData();
            this.filter = '';
            this.filter_1 = '';
            this.cloneTable = [];
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    user_fullname: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor = 90;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_user_fullname = false;
                this.columns_user_fullname = false;
                this.columns_action_type = false;
                this.columns_action_time = false;
                this.columns_topic = false;

                this.columns_disabled = false;
            } else if (this.columnsSelectorDialog.length == 6) {
                this.columns_index = true;
                this.columns_user_fullname = true;
                this.columns_user_fullname = true;
                this.columns_action_type = true;
                this.columns_action_time = true;
                this.columns_topic = true;

                this.columns_disabled = true;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    getData.push(this.columnsSelector[index].dataKey);
                }

                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'user_username') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_username')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_action_type = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_action_type = false;
                    }

                    if (element == 'action_time') {
                        this.columns_action_time = true;
                    } else if (!getData.includes('action_time')) {
                        this.columns_action_time = false;
                    }

                    if (element == 'topic') {
                        this.columns_topic = true;
                    } else if (!getData.includes('topic')) {
                        this.columns_topic = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        },

        EditPDF_1() {
            this.displayEditPDF_1 = true;
            this.columnsSelectorDialog_1 = this.columnsSelector_1;
        },
        SaveEditPDF_1() {
            if (this.columnsSelectorDialog_1.length <= 4) {
                this.PDF_minCellWidthVer_1 = 120;
                this.PDF_FontHeaderVer_1 = 15;
                this.PDF_FontBodyVer_1 = 12;

                this.PDF_BodySizeSelect_1 = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor_1 = 130;
                this.PDF_FontHeaderHor_1 = 15;
                this.PDF_FontBodyHor_1 = 12;

                this.PDF_BodySizeHorSelect_1 = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog_1.length <= 6) {
                this.PDF_minCellWidthVer_1 = 70;
                this.PDF_FontHeaderVer_1 = 15;
                this.PDF_FontBodyVer_1 = 12;
                this.PDF_BodySizeSelect_1 = {
                    index: { cellWidth: 35 },
                    user_fullname: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor_1 = 90;
                this.PDF_FontHeaderHor_1 = 15;
                this.PDF_FontBodyHor_1 = 12;

                this.PDF_BodySizeHorSelect_1 = {
                    index: { cellWidth: 35 }
                };
            }

            this.columnsSelector_1 = this.columnsSelectorDialog_1;

            if (this.columnsSelectorDialog_1.length == 0) {
                this.columns_index_1 = false;
                this.columns_user_fullname_1 = false;
                this.columns_user_fullname_1 = false;
                this.columns_action_type_1 = false;
                this.columns_action_time_1 = false;
                this.columns_topic_1 = false;

                this.columns_disabled_1 = false;
            } else if (this.columnsSelectorDialog_1.length == 6) {
                this.columns_index_1 = true;
                this.columns_user_fullname_1 = true;
                this.columns_user_fullname_1 = true;
                this.columns_action_type_1 = true;
                this.columns_action_time_1 = true;
                this.columns_topic_1 = true;

                this.columns_disabled_1 = true;
            } else {
                this.columns_disabled_1 = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector_1.length; index++) {
                    getData.push(this.columnsSelector_1[index].dataKey);
                }

                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector_1.length; index++) {
                    const element = this.columnsSelector_1[index].dataKey;

                    if (element == 'index') {
                        this.columns_index_1 = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index_1 = false;
                    }

                    if (element == 'user_username') {
                        this.columns_user_fullname_1 = true;
                    } else if (!getData.includes('user_username')) {
                        this.columns_user_fullname_1 = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname_1 = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname_1 = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_action_type_1 = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_action_type_1 = false;
                    }

                    if (element == 'action_time') {
                        this.columns_action_time_1 = true;
                    } else if (!getData.includes('action_time')) {
                        this.columns_action_time_1 = false;
                    }

                    if (element == 'topic') {
                        this.columns_topic_1 = true;
                    } else if (!getData.includes('topic')) {
                        this.columns_topic_1 = false;
                    }
                }
            }

            this.displayEditPDF_1 = false;
            this.filter = '';
        },
        CloseEditPDF_1() {
            this.displayEditPDF_1 = false;
        },
        ClearEditPDF_1() {
            this.columnsSelectorDialog_1 = [];
        },
        SelectAllEditPDF_1() {
            this.columnsSelectorDialog_1 = this.columns_1;
        }
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT {
    width: 149px;
}

@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}

.stat-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    background-color: #fafafa;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #e0e0e0;
}

.stat-item:last-child {
    border-bottom: none;
}

.stat-label {
    font-weight: 600;
    color: #333;
}

.stat-value {
    font-size: 1.1rem;
    color: #007ad9;
}

.stat-note {
    font-size: 0.9rem;
    color: #666;
}
</style>
